// removed by extract-text-webpack-plugin
module.exports = {"root":"sliderFullscreenSection__root--1CyKO","sliderButton":"sliderFullscreenSection__sliderButton--nnd9r","nextSlide":"sliderFullscreenSection__nextSlide--20ALH sliderFullscreenSection__sliderButton--nnd9r","prevSlide":"sliderFullscreenSection__prevSlide--3iTaz sliderFullscreenSection__sliderButton--nnd9r","sliderImg":"sliderFullscreenSection__sliderImg--1ZarF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/SliderFullscreenSection/sliderFullscreenSection.css
// module id = QOpe
// module chunks = 0